import { produce } from 'immer'
import type { State } from '../../typings'

export const closeEditActivityProducer = produce<State>((draft) => {
  draft.editActivityId = undefined
  draft.anchorEl = null
  draft.editStatusActivityId = undefined
})
